<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Account</h3>
        <div class="card-actions">
          <div class="card-actions btn-actions">
            <div
              style="cursor: pointer"
              @click="refreshAccountData()"
              class="btn-action"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"></path>
                <path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"></path>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-auto">
            <span
              class="avatar avatar-lg card-link"
              style="cursor: pointer"
              @click="uploadPhoto()"
              ><!-- Download SVG icon from http://tabler-icons.io/i/currency-dollar -->
              <img :src="getUserImage()" />
            </span>
            <input
              id="file-upload"
              name="upload_cont_img"
              type="file"
              style="display: none"
            />
          </div>
          <div class="col">
            <div class="">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon icon-tabler icon-tabler-mail"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <rect x="3" y="5" width="18" height="14" rx="2"></rect>
                  <polyline points="3 7 12 13 21 7"></polyline>
                </svg>
                Email: <strong>{{ user.Email }}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card mt-3">
      <div class="card-header">
        <h3 class="card-title">Password</h3>
      </div>
      <div class="card-body">
        <div class="mb-3">
          <label class="form-label">Current password</label>
          <div class="input-group input-group-flat">
            <input
              v-model="CurrentPassword"
              :type="ShowCurrentPassword ? 'text' : 'password'"
              class="form-control"
              placeholder="Current password"
              autocomplete="current-password"
            />
            <span class="input-group-text">
              <a
                href="#"
                class="link-secondary"
                :title="ShowCurrentPassword ? 'Hide password' : 'Show password'"
                @click.prevent="ShowCurrentPassword = !ShowCurrentPassword"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path>
                  <path
                    d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6"
                  ></path>
                  <path v-if="ShowCurrentPassword" d="M3 3l18 18"></path>
                </svg>
              </a>
            </span>
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label">New password</label>
          <div class="input-group input-group-flat">
            <input
              v-model="NewPassword"
              :type="ShowNewPassword ? 'text' : 'password'"
              class="form-control"
              placeholder="New password"
              autocomplete="new-password"
            />
            <span class="input-group-text">
              <a
                href="#"
                class="link-secondary"
                :title="ShowNewPassword ? 'Hide password' : 'Show password'"
                @click.prevent="ShowNewPassword = !ShowNewPassword"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path>
                  <path
                    d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6"
                  ></path>
                  <path v-if="ShowNewPassword" d="M3 3l18 18"></path>
                </svg>
              </a>
            </span>
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label">Repeat new password</label>
          <div class="input-group input-group-flat">
            <input
              v-model="RepeatNewPassword"
              :type="ShowRepeatNewPassword ? 'text' : 'password'"
              class="form-control"
              placeholder="Repeat new password"
              autocomplete="new-password"
            />
            <span class="input-group-text">
              <a
                href="#"
                class="link-secondary"
                :title="
                  ShowRepeatNewPassword ? 'Hide password' : 'Show password'
                "
                @click.prevent="ShowRepeatNewPassword = !ShowRepeatNewPassword"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path>
                  <path
                    d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6"
                  ></path>
                  <path v-if="ShowRepeatNewPassword" d="M3 3l18 18"></path>
                </svg>
              </a>
            </span>
          </div>
        </div>
        <span
          style="color: red"
          v-if="NewPassword && NewPassword.length < minPasswordLength"
          >Password must be at least {{ minPasswordLength }} characters</span
        >
        <span
          style="color: red"
          v-else-if="RepeatNewPassword && NewPassword !== RepeatNewPassword"
          >Passwords doesn't match</span
        >
        <div class="form-footer">
          <button
            :disabled="!isPasswordFormValid || isSaving"
            type="submit"
            class="btn btn-primary"
            @click="changePassword()"
          >
            Change password
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import { refreshToken } from '@/api/authentication'

import { api } from '@/api'
export default {
	data () {
		return {
			CurrentPassword: '',
			NewPassword: '',
			RepeatNewPassword: '',
			ShowCurrentPassword: false,
			ShowNewPassword: false,
			ShowRepeatNewPassword: false,
			isSaving: false,
			minPasswordLength: 8
		}
	},
	components: {},
	computed: {
		...mapState({
			user: (state) => state.user
		}),
		isPasswordFormValid () {
			return (
				this.CurrentPassword &&
				this.NewPassword.length >= this.minPasswordLength &&
				this.NewPassword === this.RepeatNewPassword
			)
		}
	},
	methods: {
		...mapMutations(['loginSuccess']),
		uploadPhoto () {
			const input = document.getElementById('file-upload')
			input.click()
			input.onchange = function () {
				const file = input.files[0]
				const formData = new FormData()
				formData.append('file', file)
				api.post('/user/image', formData).then(() => {
					document.location.reload()
				})
			}
		},
		getUserImage () {
			return api.defaults.baseURL + '/user/image'
		},
		refreshAccountData () {
			refreshToken().then((data) => {
				if (data.Status === 'ok') {
					this.loginSuccess(data.Data)
				}
			})
		},
		changePassword () {
			if (!this.isPasswordFormValid) {
				return
			}
			this.isSaving = true
			api
				.post('/user/password', {
					Password: this.CurrentPassword,
					NewPassword: this.NewPassword
				})
				.then((response) => {
					if (response.data.Status === 'ok') {
						this.clearPasswordForm()
						this.$swal.fire({
							icon: 'success',
							text: response.data.Data
						})
					}
				})
				.catch((err) => {
					this.$swal.fire({
						icon: 'error',
						text: err?.response?.data?.Data
					})
				})
				.finally(() => {
					this.isSaving = false
				})
		},
		clearPasswordForm () {
			this.CurrentPassword = ''
			this.NewPassword = ''
			this.RepeatNewPassword = ''
			this.ShowCurrentPassword = false
			this.ShowNewPassword = false
			this.ShowRepeatNewPassword = false
		}
	}
}
</script>
